import React, { useEffect, useState } from 'react';
import SidebarProfile from '../Sidebar/components/SidebarProfile/SidebarProfile';
import Sidebar from '../Sidebar/Sidebar';
import { deliveryStep1, deliveryStep2, deliveryStep3 } from '../../assets/images';
import { Span } from '../Text/Text';
import { useLocation, useNavigate } from 'react-router-dom';
import { useAppSelector } from '../../store/hooks';
import { selectDeliveryServiceStep, selectIsDeliveryServicePaymentAvailable } from '../../store/selectors/appSelectors';
import { clss } from '../../utils/helpers/styleHelpers';

import styles from './deliverySidebar.module.scss';

const DeliverySidebar = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const deliveryServiceStep = useAppSelector(selectDeliveryServiceStep);
    const isDeliveryServicePaymentAvailable = useAppSelector(selectIsDeliveryServicePaymentAvailable);

    const handleNavigate = (step: number) => {
        if (deliveryServiceStep !== 1) {
            //@ts-ignore
            const deliveryId = location.pathname.split('/').at(-1);
            if (step === 2) {
                navigate(`/deliveries/${deliveryId}`)
            } else if (step === 3 && isDeliveryServicePaymentAvailable) {
                navigate(`/projects/order-payment/${deliveryId}`)
            }
        }
    }


    return (
        // The sidebarWrapper class is what the PageWrapper grid matches to place this panel in the
        // "side" column (and keep <main> out of it). Without it the sidebar and main overlap.
        <div className={styles.sidebarWrapper}>
        <Sidebar>
            <div className={styles.wrapper}>
                <SidebarProfile />
                <ul>
                    <li className={deliveryServiceStep === 1 ? styles.selected : ''}>
                        <img src={deliveryStep1} alt="step 1" />
                        <span>1. <Span>Create campaign</Span></span>
                    </li>
                    <li
                        className={clss(
                            [
                                deliveryServiceStep === 2 ? styles.selected : '',
                                deliveryServiceStep !== 1 ? styles.availableStep : '',
                            ]
                        )}
                        onClick={() => handleNavigate(2)}
                    >
                        <img src={deliveryStep2} alt="step 2" />
                        <span>2. <Span>Upload media files to be broadcast</Span></span>
                    </li>
                    <li
                        className={clss(
                            [
                                deliveryServiceStep === 3 ? styles.selected : '',
                                (deliveryServiceStep !== 1 && isDeliveryServicePaymentAvailable) ? styles.availableStep : '',
                            ]
                        )}
                        onClick={() => handleNavigate(3)}
                    >
                        <img src={deliveryStep3} alt="step 3" />
                        <span>3. <Span>Payment</Span></span>
                    </li>
                </ul>
            </div>
        </Sidebar>
        </div>
    );
};

export default DeliverySidebar;